<div class="app-shell">
  <router-outlet />

  <footer class="app-version" aria-label="Версія застосунку">
    {{ version }}
  </footer>
</div>
